import './bootstrap';

require('admin-lte/plugins/bootstrap/js/bootstrap');

require('@lgaitan/pace-progress');

require('admin-lte');

// from: https://stackoverflow.com/questions/5852767/possible-to-defer-loading-of-jquery
// When jQuery is finaly ready
$(function() {
    // Replace previous implementation
    window.jQueryReady = function(fn) {
        // jQuery is loaded call immediately
        fn();
    }

    // Call all saved callbacks
    for (var i = 0; i < window.jQuery_store.length; ++i) {
        try {
            window.jQuery_store[i]();
        } catch (err) {
            console.log(err);
        }
    }
});

// Ativa os plugins tooltip e popover.
$('[data-toggle="tooltip"]').tooltip({boundary: 'window'});
$('[data-toggle="popover"]').popover({container: 'body', trigger: 'hover focus', html: true});

window.setRequiredIconTo = function ($el) {
    $('label[for=' + $el.attr('id') + ']').append('<a href="javascript:;" class="btn btn-xs p-0 m-0 ml-1" data-toggle="tooltip" title="Este campo é obrigatório"><i class="fas text-danger fa-asterisk"></i></a>');
}

/**
 * @param {Object} $el Input element that's required.
 */
 window.identifyRequiredField = function ($el) {
    $('label[for=' + $el.attr('id') + '] > span').append('<span class="ml-1 text-danger" aria-hidden="true">*</span>');
}

$('[required]').each(function (index) { window.identifyRequiredField($(this)); });

require('./inputmask.settings');

import Swal from 'sweetalert2';
window.toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 5000
});
